import * as React from 'react';

import {ButtonCard} from '../card/button-card';
import {colors} from '../colors/colors';
import {UpgradePillButton} from '../limits/upgrade-pill-button';
import type {UpgradePillProps} from '../limits/upgrade-pill-button';
import {Body} from '../typography/body';
import {Title} from '../typography/title';

import styles from './option-card.module.css';

type Props = {
    onClick?: () => any;
    title: string | null | undefined;
    body: string | React.ReactNode;
    upgradePillProps?: UpgradePillProps;
    autoFocus?: boolean;
    cta?: string;
    icon?: React.ComponentType<any> | React.ReactNode;
    isFullHeight?: boolean;
    isSelected?: boolean;
};

/**
 * Laid out in rows (and columns of 2-3) these cards should always contain an icon, title, and body text.
 */
export function OptionCard(props: Props) {
    const Icon = props.icon && typeof props.icon === 'function' ? props.icon : null;
    const iconComponent = props.icon && typeof props.icon === 'object' ? props.icon : null;

    return (
        <ButtonCard
            isSelected={props.isSelected}
            autoFocus={props.autoFocus}
            onClick={props.onClick}
        >
            <div
                className={
                    props.isFullHeight
                        ? styles['content-container--full-height']
                        : styles['content-container']
                }
            >
                {Icon ? <Icon fill={colors.blue} size={24} /> : undefined}
                {iconComponent ? iconComponent : undefined}
                <div className={styles['text-container']}>
                    <div className='flex gap-8 align-center'>
                        {props.title ? <Title>{props.title}</Title> : undefined}
                        {props.upgradePillProps && (
                            <UpgradePillButton {...props.upgradePillProps} />
                        )}
                    </div>
                    <Body>{props.body}</Body>
                    {props.cta ? <div className={styles.cta}>{props.cta}</div> : undefined}
                </div>
            </div>
        </ButtonCard>
    );
}
